import { useMaestroStore } from '../store/maestroStore';
import type { ZoneRow } from './zoneUsbDacRemap';
import {
  isGenericUsbDacDisplayName,
  remapSavedUsbDacZone,
  resolveGenericUsbDacToLocalNative,
} from './zoneUsbDacRemap';

/** Saved-id hydration: generic USB DAC label → live local-native zone (#1544). */
export function hydrateGhostUsbDacZone(savedId: string, zones?: ZoneRow[]): ZoneRow | null {
  const store = useMaestroStore.getState();
  const list = zones ?? store.discovery?.discoveredZones ?? [];
  if (!list.length) return null;
  let metaName: string | null = null;
  try {
    const raw = localStorage.getItem('maestro_saved_zone_meta');
    if (raw) {
      const parsed = JSON.parse(raw) as { id?: string; name?: string };
      if (String(parsed?.id || '') === savedId) metaName = String(parsed.name || '');
    }
  } catch { /* quota */ }
  const fromRemap = remapSavedUsbDacZone(savedId, list, store.selectedUsbDac);
  if (fromRemap) return fromRemap;
  if (metaName && isGenericUsbDacDisplayName(metaName)) {
    return resolveGenericUsbDacToLocalNative(list, store.selectedUsbDac);
  }
  return null;
}
